'use strict';

angular.module('followUpModule', []);